import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { TrackingEvent } from 'webapp/enums/tracking';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class ReportsPagelessViewSwitchTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.REPORTS_PAGELESS_VIEW_SWITCH;
	override trackEvent: TrackingEvent | '' = TrackingEvent.BUBBLE_REPORTS_PAGELESS_VIEW_SWITCH;

	get id(): string {
		return TourId.REPORTS__PAGELESS_VIEW_SWITCH;
	}

	override get keyForPersistantDone(): string {
		return ReportsPagelessViewSwitchTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.DOWN,
				allowStacked: false,
				attachTo: () => {
					// Target the view switcher component in the header
					return $('.view-switcher');
				},
				scrollToAttachTo: true,
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}

	override onExplicitClose(): void {
		this.flowTourReportsPagelessService.endAllTours();
		super.onExplicitClose();
	}
}
